<template>
  <v-dialog v-model="viewModel.dialog.value" persistent max-width="600px">
    <v-card>
      <!-- Título del Diálogo -->
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-subtitle-1 font-weight-bold">
          Solicitar Transferencia
        </span>
        <v-btn icon flat @click="viewModel.closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Contenido del Diálogo -->
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="viewModel.selectedAccount.value"
                :items="viewModel.accounts.value"
                item-title="nom"
                item-value="idbancocuenta"
                label="Seleccione una cuenta"
                variant="outlined"
                compact="dense"
                hide-details
                return-object
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="viewModel.amount.value"
                :prefix="
                  viewModel.getCoin(
                    viewModel.selectedAccount.value?.moneda ?? 1
                  )
                "
                label="Monto"
                variant="outlined"
                compact="dense"
                hide-details
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-alert
                type="info"
                variant="tonal"
                class="mt-2"
                text="Recuerde que el límite de transferencia es de 10,000."
              ></v-alert>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <!-- Acciones del Diálogo -->
      <v-card-actions class="d-flex justify-end">
        <v-btn
          color="primary"
          :loading="viewModel.loading.value"
          :disabled="
            !viewModel.selectedAccount.value ||
            !viewModel.amount.value ||
            viewModel.loading.value
          "
          @click="viewModel.confirm"
        >
          Confirmar
        </v-btn>
        <v-btn color="secondary" @click="viewModel.closeDialog">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { defineExpose } from "vue";
import { Account } from "@/models/Account";
import TransferDialogViewModel from "@/viewmodels/dialogs/TransferDialogViewModel";

const viewModel = new TransferDialogViewModel();

// Exponemos directamente los métodos sin usar `bind`
defineExpose({
  openDialog: (accounts: Account[]) => viewModel.openDialog(accounts),
  closeDialog: () => viewModel.closeDialog(),
});
</script>
